module.exports = __webpack_public_path__ + "media/images/expert__selectedArrow-cfb700c5315ab11b41c9f93b4b716d44.png";